const language = 'croatian';
export const langDir = 'ltr';

export default language;
